import { NeuButton } from '@hcahealthcaredpx/neutron-react';

import styles from '../profile.module.css';

type AppointmentButtonProps = {
  locationId: string;
  buttonText: string;
  onClick: () => void;
  appointmentButtonId: string;
};

// This component combines two state cases:
// 1. When we want to show MHD steps logic (e.g., booking an appointment through MHD).
// 2. When we want to redirect to the Healow link in a new tab.
// The behavior is determined by the `onClick` prop, which is passed from the parent component.
export const AppointmentButton: React.FC<AppointmentButtonProps> = ({
  locationId,
  buttonText,
  onClick,
  appointmentButtonId,
}) => (
  <div className={styles.addressButton}>
    <NeuButton key={locationId} className="w-100" onClick={onClick} id={appointmentButtonId}>
      {buttonText}
    </NeuButton>
  </div>
);
